import React from 'react';
import { ModalButtonSave, ModalButtonUpdate } from '../../constant';
import { FormSite } from './FormSite';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';


export const ModalSite = (props) => {
    const {
        method, modalTitle, loading, modal, toggle,
        handleInputChange, saveCreate, saveUpdate, saveDelete,
        validaciones, name,

        closeDialog
    } = props;


    return (
        <Dialog
            // header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-spoon-and-fork f-30"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v3`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdate}
                        >
                            {
                                loading ? "Actualizando...." : "Actualizar"
                            }
                        </Button>
                    }
                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}>
                        Cancelar
                    </Button>
                </>
            }

        >

            {
                method === "create"
                    ? <FormSite
                        button={ModalButtonSave}
                        {...{ toggle, loading, handleInputChange, validaciones, closeDialog, methodAction: saveCreate, }}
                    />
                    :
                    (method === "update")
                        ?
                        <FormSite
                            button={ModalButtonUpdate}
                            {...{ toggle, loading, handleInputChange, validaciones, closeDialog, methodAction: saveUpdate, name }}
                        />
                        :
                        null
            }
        </Dialog>
    )
}